
import { Component, Emit, Prop, Vue, Watch } from "vue-property-decorator";
import { CardValidation, ParkActionOptionsResult } from "@/store/rules-engine/types";
import RulesNumberInput from "@/components/rules-engine-setup/data-components/RulesNumberInput.vue";
import RulesTimeDurationInput from "@/components/rules-engine-setup/data-components/RulesTimeDurationInput.vue";
import { namespace } from "vuex-class";

const RuleStore = namespace('rulesEngine');

@Component({
	components: {
		"rules-number-input": RulesNumberInput,
		"rules-time-duration-input": RulesTimeDurationInput
	}
})
export default class ParkActionOptionsInput extends Vue {
    @Prop()
    private value: ParkActionOptionsResult;

	@Prop({type: String})
    private placeholderText: string;

	@Prop({type: String})
    private placeholderTextMinutes: string;

	@Prop({type: String})
    private placeholderTextSeconds: string;

	@Prop({type: Number})
    private minValue: number;

	@Prop({type: Number})
    private maxValue: number;

	@Prop({type: Number})
	private minDurationValue: number;

	@Prop({type: Number})
	private maxDurationValue: number;

	@Prop({type: Boolean})
	private allowDecimal: boolean;

	@Prop({type: Boolean})
	private allowNulls: boolean;

	@Prop({type: Boolean})
	private readOnly: boolean;

	@Prop({type: String})
	private dataCyForPark: string;

	@Prop({type: String})
	private dataCyForMinutes: string;

	@Prop({type: String})
	private dataCyForSeconds: string;

	private inputNumber: number = null;

    private inputDuration: number = null;

	private inputValidation: CardValidation = { isValid: false, message: ""};

	private inputNumberValidation: CardValidation;

	private inputDurationValidation: CardValidation;

    private mounted(): void {
        this.valueUpdate();
    }

    @Watch("value")
    private valueUpdate(): void
    {
		this.inputNumber = this.value ? this.value.parkCount : null;
		this.inputDuration = this.value ? this.value.duration : null;
    }

	@Emit("isValid")
    private validateInput(): CardValidation
    {
		if (!this.inputNumberValidation.isValid) {
			this.inputValidation.isValid = false;
			this.inputValidation.message = "*Park Count must contain a valid value";
			return this.inputValidation;
		}
		else if (!this.inputDurationValidation.isValid) {
			this.inputValidation.isValid = false;
			this.inputValidation.message = this.inputDurationValidation.message;
			return this.inputValidation;
		}

		this.inputValidation.isValid = true;
		this.inputValidation.message = null;
        return this.inputValidation;
	}

	@Watch("inputNumber")
	@Watch("inputDuration")
	@Emit("input")
	private emitParkActionResult(): ParkActionOptionsResult {
		return {
			parkCount: this.inputNumber,
			duration: this.inputDuration
		};
	}

	private durationValueUpdated(duration: number): void {
		this.inputDuration = duration;
	}

	private durationValidityUpdated(cardValidation: CardValidation): void {
		this.inputDurationValidation = cardValidation;
		this.validateInput();
	}

	private parkCountValueUpdated(parkCount: number): void {
		this.inputNumber = parkCount;
	}

	private parkCountValidityUpdated(cardValidation: CardValidation): void {
		this.inputNumberValidation = cardValidation;
		this.validateInput();
	}
}
